import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  changeState,
  fetchTags,
  toggleNav,
  setCurrent,
  updateQuiz
} from '../actions/index';
import { HELPERS, ASSET_PREFIX, CONSTANTS } from '../config/constants';

import QbankButton from '../components/QbankButton';

import initGrey from '../images/init-quiz-grey.png';
import dashGrey from '../images/dashboard-grey.png';
import flagGrey from '../images/quiz-history-gray@3x.png';
import setGrey from '../images/settings-grey.png';
import lecIcon from '../images/lectures-icon.png';
import emIcon from '../images/em-dashboard-icon.png';
import '../styles/Navbar.css';

const isStage = window.location.hostname.indexOf('stage') > 0;

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.navToHistory = this.navToHistory.bind(this);
  }

  navToHistory() {
    this.props
      .changeState('history')
      .then(() => (this.props.navOpen ? this.props.toggleNav() : null));
  }

  render() {
    const flagColor = this.props.product
      ? require(`../images/${
          ASSET_PREFIX[this.props.product]
        }-quiz-history@3x.png`)
      : null;
    const dashColor = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-graph@3x.png`)
      : null;
    const setColor = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-gear@3x.png`)
      : null;
    const initColor = this.props.product
      ? require(`../images/${ASSET_PREFIX[this.props.product]}-quiz@3x.png`)
      : null;
    return (
      <div className="navbar-wrapper">
        <div className="navbar">
          <div className="navbar-item selected navbar-state-icons">
            <img
              alt=""
              title="Quiz"
              src={this.props.currentState === 'init' ? initColor : initGrey}
              className={
                this.props.currentState === 'init'
                  ? 'navbar-icon selected'
                  : 'navbar-icon'
              }
              onClick={() =>
                this.props
                  .changeState('init')
                  .then(
                    () => (this.props.navOpen ? this.props.toggleNav() : null)
                  )
              }
            />
            <img
              alt=""
              title="Dashboard"
              src={
                this.props.currentState === 'dashboard' ? dashColor : dashGrey
              }
              className={
                this.props.currentState === 'dashboard'
                  ? 'navbar-icon selected'
                  : 'navbar-icon'
              }
              onClick={() =>
                this.props
                  .changeState('dashboard')
                  .then(() =>
                    this.props
                      .fetchTags()
                      .then(
                        () =>
                          this.props.navOpen ? this.props.toggleNav() : null
                      )
                  )
              }
            />
            <img
              alt=""
              title="History"
              src={this.props.currentState === 'history' ? flagColor : flagGrey}
              className={
                this.props.currentState === 'history'
                  ? 'navbar-icon selected'
                  : 'navbar-icon'
              }
              onClick={() => this.navToHistory()}
            />
            {!this.props.isTrial ? (
              <img
                alt=""
                title="Settings"
                src={
                  this.props.currentState === 'settings' ? setColor : setGrey
                }
                className={
                  this.props.currentState === 'settings'
                    ? 'navbar-icon selected'
                    : 'navbar-icon'
                }
                onClick={() =>
                  this.props
                    .changeState('settings')
                    .then(
                      () => (this.props.navOpen ? this.props.toggleNav() : null)
                    )
                }
              />
            ) : null}
          </div>
          <div
            className="clickable navbar-item lec-row"
            onTouchTap={() =>
              (window.location = isStage
                ? 'https://hippostage.silverorange.com/hippo-pa/work-pa-qbank/www/account/aapa-review'
                : `https://www.hippoed.com/${ASSET_PREFIX[
                    this.props.product
                  ].toLowerCase()}/boardreview`)
            }
          >
            <img alt="" src={lecIcon} className="lec-icon" />
            <span>
              {this.props.product
                ? 'pa' ===
                  Object.keys(CONSTANTS.PRODUCT_ID).filter(
                    k => CONSTANTS.PRODUCT_ID[k].id === this.props.product
                  )[0]
                  ? 'AAPA REVIEW'
                  : `${ASSET_PREFIX[this.props.product].toUpperCase()} `
                : ''}
              {`${
                'pa' ===
                Object.keys(CONSTANTS.PRODUCT_ID).filter(
                  k => CONSTANTS.PRODUCT_ID[k].id === this.props.product
                )[0]
                  ? ''
                  : 'VIDEOS'
              }`}
            </span>
            {!this.props.hasBoardReview ? (
              <p className="upsell">Upgrade!</p>
            ) : null}
          </div>
          <div
            className="navbar-item clickable"
            onTouchTap={() =>
              (window.location = isStage
                ? 'https://hippostage.silverorange.com/hippo-pa/work-pa-qbank/www/account/details'
                : `https://www.hippoed.com/${ASSET_PREFIX[
                    this.props.product
                  ].toLowerCase()}/account/details`)
            }
          >
            <div className="clickable">
              <img alt="" src={emIcon} className="em-icon" />
              <span>
                {this.props.product
                  ? ASSET_PREFIX[this.props.product].toUpperCase()
                  : ''}{' '}
                DASHBOARD
              </span>
            </div>
          </div>
        </div>
        {this.props.isTrial ? (
          <div className="nav-trial">
            <p className="nav-trial-text">FREE TRIAL</p>
            <p className="nav-trial-text">Get the full version!</p>
            <QbankButton
              style={{ fontSize: '12px', margin: '0 0 0 0', paddingTop: '' }}
              height="35px"
              width="140px"
              label="UPGRADE NOW"
              onClick={() =>
                (window.location = `https://www.hippoed.com/${ASSET_PREFIX[
                  this.props.product
                ].toLowerCase()}/${
                  ASSET_PREFIX[this.props.product] === 'pa' ? 'aapa-' : ''
                }qbank`)
              }
            />
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const isTrial = state.app.user ? state.app.user.isTrial : null;
  const hasBoardReview = state.app.user ? state.app.user.hasBoardReview : null;
  const app = state.app || {};

  return {
    product: app.product,
    isTrial,
    hasBoardReview,
    filtered: state.filtered,
    currentState: state.currentState.state,
    navOpen: state.app.navOpen
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { changeState, fetchTags, toggleNav, setCurrent, updateQuiz },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/containers/Navbar.js